var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76386 3.63886C7.49538 3.90735 7.49538 4.34265 7.76386 4.61114L14.1527 11L7.76386 17.3889C7.49538 17.6574 7.49538 18.0927 7.76386 18.3611C8.03235 18.6296 8.46765 18.6296 8.73614 18.3611L15.6111 11.4861C15.8796 11.2177 15.8796 10.7823 15.6111 10.5139L8.73614 3.63886C8.46765 3.37038 8.03235 3.37038 7.76386 3.63886Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.c23aa0011cbd8e1375b81d810a2c9ea7.svg";
export { ForwardRef as ReactComponent };